import http from '../../services/http'
import queryString from 'query-string'
import store from '../index'
import * as types from '../types/comanda'
import {onlyNumbers} from '../../helpers'

export const getMesas = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/mesa/listar?${qry}`).then((response) => {
      const mesas = response.data;
      dispatch([
        { type: types.MESAS_LIST, payload: mesas },
        { type: types.MESAS_LOADING, payload: false },
      ]);
    });
  };
};

export const getCategorias = () => {
    return dispatch => {
        http.get(`/api/v2/comanda/listar_categorias`).then( response => {
            const categorias = response.data
            dispatch([
                {type: types.LIST_CATEGORIAS, payload: categorias}
            ])
        })
    }
}

export const getClis = (filtro) => {
    const qry = queryString.stringify(filtro, {arrayFormat: 'index'});
    return dispatch => {
        http.get(`/api/v2/comanda/listar_clientes?${qry}`).then( response => {
            const clientes = response.data
            dispatch([
                {type: types.CLIENTES_LIST, payload: clientes},
            ])
        })
    }
}

export const loadCliItems = (cliente_id) => {
    return dispatch => {
        http.post(`/api/v2/comanda/listar_cliente_items`, cliente_id).then(
            response => {
                console.log(response.data)
                dispatch([
                    {type: types.ITEMS_LISTA, payload: response.data}
                ])},
            error => {console.log(error)}
        )
    }
}

export const setNewMesa = (dados) => {
  return new Promise((resolve, reject) => {
    http.post(`/api/v2/mesa/adicionar`, dados).then(
      (resp) => {
        resolve(resp.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const getMesaSel = (dados) => {
    return dispatch => {
        http.post(`/api/v2/mesa/resumo_geral`, dados).then(
            resp=>{
                dispatch([
                {type: types.MESA_SELECTED, payload: resp.data.mesa},
                {type: types.CLIENTES_MESA_LISTA, payload: resp.data.clientes},
                {type: types.ITEMS_LISTA, payload: resp.data.items}
            ])},
            error=>{dispatch([
                {type: types.MESA_SELECTED, payload: {}}
            ])}
        )
    }
}

export const filterListaItems = (filtro) => {
    return dispatch => {
        http.post(`/api/v2/comanda/listar_item`, filtro).then(
            resp=>{
                dispatch([
                    {type: types.ITEMS_LISTA, payload: resp.data}
                ])
            },
            err=>{
                dispatch([
                    {type: types.ITEMS_LISTA, payload: [{}]}
                ])
            }
        )
    }
}

export const loadCardapio = (filtro) => {
    const qry = queryString.stringify(filtro, {arrayFormat: 'index'});
    return dispatch =>{
        
        http.post(`/api/v2/empresa/produtos/cardapio_interno?${qry}`).then(
            resp=>{
                dispatch([
                {type: types.CARDAPIO, payload: resp.data.data},
                {type: types.SET_PROD_PAGE, payload: resp.data.current_page},
                {type: types.SET_PROD_PERPAGE, payload: resp.data.per_page},
                {type: types.SET_PROD_TOTAL, payload: resp.data.total}
                ])
            },
            error=>{
                dispatch([
                    {type:types.CARDAPIO, payload: error}
                ])
            }
        )
    }
}


export const searchCpf = cpf => {
    return new Promise( (resolve, reject) => {
        http.get(`/api/v2/app/usuarios/consulta?cpf=${onlyNumbers(cpf)}`).then(
            resp => resolve(resp.data),
            err=> reject(err)
        )
    })
}

export const insertCli = (mesa_id, cliente_id) => {
    let body = {mesa_id, cliente_id};
    return dispatch =>{
        http.post(`/api/v2/comanda/abrir_estabelecimento`, body).then(
            resp=>{
                dispatch([
                {type: types.SET_DIALOG, payload: {show: true, title: 'Sucesso!', description:resp.data.success}},
                ])
            },
      (error) => {
        console.log(error);
        dispatch([
          {
            type: types.SET_DIALOG,
            payload: {
              show: true,
              title: "Ops, ocorreu algum erro!",
              description: "ops",
            },
          },
        ]);
      }
    );
  };
};

export const insertItem = (mesa_id, item_id, cliente_id) => {
    let body = {mesa_id, item_id, cliente_id};

    return dispatch => {
        http.post(`/api/v2/comanda/inserir_estabelecimento`,body).then(
            resp=>{
                dispatch([
                    {type: types.SET_DIALOG, payload: {show: true, title: 'Sucesso!', description: resp.data.success}}
                ])
      },
      (err) => {
        dispatch([
          {
            type: types.SET_DIALOG,
            payload: {
              show: true,
              title: "Ops, ocorreu algum erro!",
              description: err,
            },
          },
        ]);
      }
    );
  };
};

export const transferItems = (cliente_id, items_ids) => {
    let params = {products_ids: items_ids, cliente_id: cliente_id}

    return dispatch => {
        http.post(`/api/v2/comanda/transferir_comanda`, params).then(
            resp => {
                dispatch([
                    {type:types.SET_DIALOG, payload: {show:true, title: 'Sucesso!', description: 'Produtos Transferidos com Sucesso!'}}
                ])
            },
            err => {
                dispatch([
                    {type:types.SET_DIALOG, payload: {show: true, title: 'Ops, ocorreu algum erro!', description: 'Ocorreu Algum Erro, tente novamente mais tarde!'}}
                ])
            }
        )
    }
}

export const getCardapioPerCat = (categoria_id) => {
  return (dispatch) => {
    http
      .get(`/api/v2/comanda/listar_produtos?categoria_id=${categoria_id}`).then(
        (resp) => {
          return dispatch([{ type: types.CARDAPIO_PDV, payload: resp.data }]);
        },
        (error) => {
          console.log(error);
        }
      );
  };
};

export const createPedidoPdv = (items) => {
  const { cliPDV, cliPDVCpf } = store.getState().comanda;
  const body = {
    items,
    referencia_pdv: cliPDV,
    cpf_nota: cliPDVCpf
  }
  return dispatch => {
    http.post(`/api/v2/comanda/adicionar_pedido_pdv`, body).then(
      resp => {
        let ret = resp.data
        dispatch([
          {type:types.SET_DIALOG, payload: {show:true, title: 'Sucesso!', description: ret.msg}}
        ])
      },
      error => {
        let ret = error.data
        dispatch([
          {type:types.SET_DIALOG, payload: {show:true, title: 'Erro!', description: ret.msg}}
        ])
      }
    )
  }
};


export const getListPedPDV = () => {
  return dispatch => {
    http.get('/api/v2/comanda/lista_pedidos_pdv').then(
      resp => {
        dispatch([
          {type: types.LIST_PEDIDOS_PDV, payload: resp.data}
        ])
      },
      error => {
        dispatch([
          //{type: types.SET_DIALOG, payload: {show: true, title: 'Erro!', description: 'Erro Interno ao Carregar a Lista de Pedidos, Por Gentileza tente novamente em alguns minutos!'}}
        ])
      }
    )
  }
}

export const getPedidoPdvById = id => {
  
  return dispatch => {
    http.get(`/api/v2/comanda/pedido_pdv?pedido_id=${id}`).then(
      resp => {
        let dados = resp.data
        let att_payload = {
          id: dados.ped.id,
          referencia: dados.ped.referencia_pdv,
          cpf_nota: dados.ped.cpf_nota || '',
          items: dados.items
        }
        
        dispatch([
          {type: types.PEDIDO_PDV_EFETIVADO , payload: att_payload},
          {type: types.PEDIDO_PDV_EDIT , payload: att_payload},
          {type: types.MESAS_LOADING, payload: false}
        ])
      },
      error => {
        dispatch([
          {type: types.SET_DIALOG, payload: {show: true, title: 'Erro!', description: 'Erro ao Carregar o pedido, Por Gentileza tente novamente em alguns minutos!'}}
        ])
      }
    )
  }
}

export const deletePedidoPDV = id => {
  return dispatch => {
    http.put(`/api/v2/comanda/cancelar_pdv/${id}`).then(
      resp => {
        dispatch([
          getListPedPDV(),
          {type: types.SET_DIALOG, payload: {show: true, title: '', description: `Pedido ${id} cancelado com sucesso!`}},
          {type: types.MESAS_LOADING, payload: false}
        ])
      },
      error => {
        console.log(error.data)
        dispatch([
          {type: types.SET_DIALOG, payload: {show:true, title:'Ops!', description: 'Ocorreu algum erro ao cancelar o pedido, tente novamente após recarregar a pagina!'}},
          {type: types.MESAS_LOADING, payload: false}
        ])
      }
      )
    }
}